<template>
  <div class="login-dropdown" :class="{ open: open }" @click="open = !open">
    <div class="value">
      <i class="icon-people"></i>
      <span v-if="userInfo.first_name && userInfo.last_name" class="name">{{ userInfo.first_name }} {{ userInfo.last_name }}</span>
      <span v-else class="name">{{ userInfo.email }}</span>
      <div class="arrow"></div>
    </div>

    <div class="dropdown-mask">
      <Transition name="dropdown">
        <div v-if="open" class="dropdown">
          <div class="content">
            <div v-if="study && study.number_of_journeys && study.number_of_journeys > 20000" class="button" @click="goToStudies">
              {{ $t('myStudies') }}
            </div>
            <RouterLink v-else :to="{ name: 'studyList' }">
              <div class="button">{{ $t('myStudies') }}</div>
            </RouterLink>
            <a v-if="isDesktop && $route.meta.tutorial" @click="() => takeTutorial()">
              <div class="button">{{ $t('tutorial.see') }}</div>
            </a>
            <a v-if="!isDesktop" :href="`${config.NXTROOM_URL}/fr`">
              <div class="button">NxT Room</div>
            </a>
            <RouterLink :to="{ name: 'Logout' }">
              <div class="button">{{ $t('disconnect') }}</div>
            </RouterLink>
            <div v-if="userInfo.role_id === 3" class="button delete-account" @click="deleteAccount">
              {{ $t('deleteMyAccount') }}
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import config from '@/config';

export default {
  name: 'LoginDropdown',

  data() {
    return {
      config,
      open: false,
    };
  },

  computed: {
    ...mapGetters({
      isLogged: 'isLogged',
      userInfo: 'userInfo',
      isDesktop: 'isDesktop',
      study: 'study',
    }),
  },

  methods: {
    takeTutorial() {
      // this.$emit('tutorialState', false)
      this.$store.dispatch('updateTutorial', false);
      this.$emit('closeModal');
      this.$router.push({ name: 'synthesis', params: { studyId: this.$route.params.studyId } });
    },

    deleteAccount() {
      this.$store.dispatch('updateCurrentModal', {
        component: 'DeleteAccount',
        params: null,
      });
    },

    goToStudies() {
      window.location.href = window.location.origin;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/animations.scss';

.login-dropdown {
  position: relative;
  height: 100%;
  width: 192px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 12px 0 8px;
  margin: 0 0 0 8px;

  border-left: solid 1px transparent;
  border-right: solid 1px transparent;

  transition: 0.2s ease-out;

  &.open {
    border-left-color: colors.$clear-border-color;
    border-right-color: colors.$clear-border-color;
  }

  .value {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.2s ease-out;

    i {
      margin-right: 8px;
    }

    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 116px;
    }

    .arrow {
      $size: 6px;
      width: $size;
      height: $size;
      transform: rotate(45deg);
      border-right: 2px solid colors.$stone-color;
      border-bottom: 2px solid colors.$stone-color;
      border-radius: 1px;
      margin: -2px 4px 2px 12px;
    }

    &:hover,
    &.open {
      color: colors.$stone-color;

      i {
        color: colors.$main-color;
      }
    }
  }

  .dropdown-mask {
    position: absolute;
    z-index: 1000;
    top: 100%;
    bottom: -256px;
    right: -25px;
    left: -25px;
    overflow-x: visible;
    overflow-y: hidden;
    pointer-events: none;

    .dropdown {
      position: absolute;
      z-index: 800;
      left: 24px;
      right: 24px;

      background: colors.$white-color;
      border: 1px solid colors.$clear-border-color;
      border-top: none;
      border-radius: 0 0 2px 2px;
      box-sizing: border-box;
      overflow: hidden;
      pointer-events: all;
      cursor: default;
      box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.4);
      transition: all 0.4s ease;

      .content {
        padding: 4px 24px 16px;
        cursor: default;

        .button {
          color: #262631;
          font-size: 14px;
          margin: 0 -24px;
          padding: 8px 24px;
          cursor: pointer;
          transition: all 0.4s ease;

          &:hover {
            color: colors.$main-color;
            opacity: 1;
          }

          &.delete-account {
            font-size: 10px;
            opacity: 0.6;
          }
        }
      }
    }
  }
}
</style>
